<script>
import ListSimulatorQuestionsComponent from '../../features/lists/ListSimulatorQuestionsComponent';
import ModalSimulatorQuestionView from '../modals/ModalSimulatorQuestionView';
import ModalImportView from '../../../shared/views/ModalImportView';


export default {
  name: 'ListSimulatorQuestionsView',
  components: {
    'modal-simulator-question-view': ModalSimulatorQuestionView,
    'modal-import': ModalImportView,
  },
  extends: ListSimulatorQuestionsComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row
      :gutter="20"
      class="section-ctrl"
    >
      <el-col
        :xs="24"
        :sm="14"
        :md="14"
        :lg="14"
        :xl="14"
        class="header-right"
      >
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Pregunta
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Preguntas
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.courseCategoryFilter"
                    :popper-append-to-body="true"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Categoria..."
                    :remote-method="onSearchCourseCategory"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.courseCategoryFilter.id, 'SimulatorQuestionCategoryId')"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in courseCategories"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.difficultyLevelFilter"
                    :popper-append-to-body="true"
                    size="small"
                    clearable
                    placeholder="Dificultad..."
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.difficultyLevelFilter.id, 'DifficultyLevel')"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in difficultyLevels"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.typeFilter"
                    :popper-append-to-body="true"
                    size="small"
                    clearable
                    placeholder="Tipo..."
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.typeFilter.id, 'SimulatorExamType')"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in types"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
      </el-col>
      <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" class="header-left search-inputs-row">
        <el-input
          v-model="filterOptions.codeFilter"
          size="small"
          placeholder="Buscar Codigo..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(filterOptions.codeFilter, 'Code')"
        />
        <el-input
          v-model="filterOptions.nameFilter"
          size="small"
          placeholder="Buscar nombre..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(filterOptions.nameFilter, 'Name')"
        />
      </el-col>
    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label="CODIGO"
        min-width="100"
      >
        <template #default="scope">
          <div>
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="NOMBRE"
        min-width="350"
      >
        <template #default="scope">
          <div>
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="CATEGORIA"
        min-width="200"
        align="center"
      >
        <template #default="scope">
          <div>
            <el-tag
              v-if="scope.row.simulatorQuestionCategory"
              type="info"
              effect="plain"
            >
              {{ scope.row.simulatorQuestionCategory.name }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="TIPO"
        min-width="110"
        align="center"
      >
        <template #default="scope">
          <div>
            <el-tag
              v-if="scope.row.type === 1"
              type="info"
              effect="plain"
            >
              PUBLICO
            </el-tag>
            <el-tag
              v-if="scope.row.type === 2"
              type="success"
              effect="plain"
            >
              PRIVADO
            </el-tag>
            <el-tag
              v-if="scope.row.type === 3"
              type="warning"
              effect="plain"
            >
              AMBAS
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="DIFICULTAD"
        min-width="110"
        align="center"
      >
        <template #default="scope">
          <div>
            <el-tag
              v-if="scope.row.difficultyLevel === 1"
              type="success"
              effect="plain"
            >
              FACIL
            </el-tag>
            <el-tag
              v-if="scope.row.difficultyLevel === 2"
              type="warning"
              effect="plain"
            >
              INTERMEDIO
            </el-tag>
            <el-tag
              v-if="scope.row.difficultyLevel === 3"
              type="danger"
              effect="plain"
            >
              DIFICIL
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="CREACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.createdAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="ACTUALIZACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            v-if="onCheckUpdatedAt(scope.row.updatedAt)"
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.updatedAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="OPCIONES"
        :width="160"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-simulator-question-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>
